import { render, staticRenderFns } from "./detail-extra.vue?vue&type=template&id=21541176&scoped=true&"
import script from "./detail-extra.vue?vue&type=script&lang=js&"
export * from "./detail-extra.vue?vue&type=script&lang=js&"
import style0 from "./detail-extra.vue?vue&type=style&index=0&id=21541176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21541176",
  null
  
)

export default component.exports